interface MultiImageSelectionButtonState {
	isDesktop: boolean;
	hasCommittedImages: boolean;
	isSelectionActive: boolean;
}

interface MultiImageCommittedControlsState {
	hasCommittedImages: boolean;
	isSelectionActive: boolean;
}

export const shouldShowDesktopSelectionButton = ({
	isDesktop,
	hasCommittedImages,
	isSelectionActive,
}: MultiImageSelectionButtonState): boolean => {
	return isDesktop && (!hasCommittedImages || isSelectionActive);
};

export const shouldShowCommittedImageControls = ({
	hasCommittedImages,
	isSelectionActive,
}: MultiImageCommittedControlsState): boolean => {
	return hasCommittedImages && !isSelectionActive;
};
